import React, { Fragment, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import styles from "./Checkout.module.scss";
import NumberFormat from "react-number-format";

const CustomerInfo = ({ app = false, register, errors, control, setValue, trigger, customer, watch }) => {
  const [phone, setPhone] = useState(customer.phone || '');
  useEffect(() => {
    if (customer.phone) {
      setPhone(customer.phone);
      setValue('phone', customer.phone);
    }
  }, [customer]);

  return (
    <Fragment>
      <h1 className={styles.header}>{app ? '2' : '1' }. Contact Information</h1>
      <label className={styles.label}>Parent/Guardian First Name:</label>
      <input
        defaultValue={customer.firstName}
        className={`${styles.input} ${errors.first_name && styles.error}`}
        {...register("first_name", { required: true })}
      />

      <label className={styles.label}>Parent/Guardian Last Name:</label>
      <input
        defaultValue={customer.lastName}
        className={`${styles.input} ${errors.last_name && styles.error}`}
        {...register("last_name", { required: true })}
      />

      <label className={styles.label}>Email:</label>
      <input
        defaultValue={customer.email}
        className={`${styles.input} ${errors.email && styles.error}`}
        {...register("email", { required: true })}
      />

      <label className={styles.label}>Phone #</label>
      <Controller
        control={control}
        name="phone"
        render={({ value }) => (
          <NumberFormat
            format="+1 (###) ###-####"
            allowEmptyFormatting mask="_"
            defaultValue={phone}
            className={`${styles.input} ${errors.phone && styles.error}`}
            inputMode='numeric'
            value={value}
            onValueChange={(v) => {
              setValue('phone', v.value);
              if (errors.phone) trigger('phone');
            }}
          />
        )}

        rules={{ required: true, minLength: { value: 10, message: "Phone number must be at least 10 numbers" } }}
      />
      {errors.phone && errors.phone.message && <p className={styles.errorMessage}>{errors.phone.message}</p>}

      <label className={styles.label}>Notes:</label>
      <textarea
        className={styles.input}
        {...register("notes", { required: false })}
      />
    </Fragment>
  )
}

export default CustomerInfo;
